module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cooperative-partner"
  }, [_c('banner', {
    attrs: {
      "hasDivider": "",
      "clazz": "cooperative-partner-banner",
      "url": "cooperativePartner"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goRegister('hezuohuobang-banner-jihua')
      }
    }
  }, [_vm._v("加入合作伙伴计划")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "cooperative-partner-section"
  }, [_c('div', {
    staticClass: "section-content"
  }, [_c('h1', {
    staticClass: "section-title"
  }, [_vm._v("合作伙伴体系")]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section-main"
  }, [_c('ul', {
    staticClass: "main-ul clearfix"
  }, _vm._l((_vm.sectionData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "main-li fl"
    }, [_c('img', {
      staticClass: "main-img",
      attrs: {
        "src": item.img,
        "alt": "合作伙伴体系"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "main-detail"
    }, [_c('h2', {
      staticClass: "main-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "main-content"
    }, [_vm._v(_vm._s(item.content))])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "cooperative-partner-section1"
  }, [_c('h1', {
    staticClass: "section1-title"
  }, [_vm._v("合作伙伴支持")]), _vm._v(" "), _c('div', {
    staticClass: "section1-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section1-content"
  }, [_c('ul', {
    staticClass: "section1-main clearfix"
  }, _vm._l((_vm.section1Data), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "section1-detail fl"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.src),
        expression: "item.src"
      }],
      staticClass: "detail-img",
      attrs: {
        "alt": item.title
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "detail-content",
      domProps: {
        "innerHTML": _vm._s(item.content.replace(/@/g, '<br/>'))
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "cooperative-partner-section2"
  }, [_c('div', {
    staticClass: "section2-content"
  }, [_c('h1', {
    staticClass: "section2-title"
  }, [_vm._v("不断推进合作伙伴的专业化协作")]), _vm._v(" "), _c('div', {
    staticClass: "section2-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section2-main"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 3000,
      "arrow": "always"
    }
  }, _vm._l((_vm.partnerData), function(item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('div', {
      staticClass: "main-region"
    }, [_c('ul', {
      staticClass: "main-content clearfix"
    }, _vm._l((item), function(item1, index1) {
      return _c('li', {
        key: index1,
        staticClass: "content-detail fl"
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: (_vm.$global.globalPath + item1.cover),
          expression: "$global.globalPath + item1.cover"
        }],
        staticClass: "detail-img",
        attrs: {
          "alt": "不断推进合作伙伴的专业化协作"
        }
      })])
    }), 0)])])
  }), 1)], 1)])]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cooperative-partner-section3"
  }, [_c('div', {
    staticClass: "section3-content"
  }, [_c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("申请流程及条件")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section3-main"
  }, [_c('img', {
    staticClass: "main-img",
    attrs: {
      "src": require("../../assets/img/cooperativePartner/section3.png"),
      "alt": "申请流程及条件"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f24e107"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutUs/cooperativePartner.vue
// module id = 611
// module chunks = 12